import { RootStackRoutes } from 'types';
import { FeatureModule } from '../earn';
import { ExchangeSubAccountNavigator, ExchangeSubAccountStackRoutes } from './exchange.navigator';
import en from './i18n/en.json';
import zhCn from './i18n/zh-CN.json';
import zhHk from './i18n/zh-HK.json';
import jaJp from './i18n/ja-JP.json';

const ExchangeSubAccountApp: FeatureModule = {
  name: RootStackRoutes.ExchangeSubAccount,
  version: '1.0.0',
  hooks: {},
  screens: {
    main: ExchangeSubAccountNavigator
  },
  routes: {
    [ExchangeSubAccountStackRoutes.Splash]: {
      path: 'exchange-sub-account'
    },
    [ExchangeSubAccountStackRoutes.Splash]: {
      path: 'exchange-sub-account/index'
    },
    [ExchangeSubAccountStackRoutes.Introduction]: {
      path: 'exchange-sub-account/introduction'
    },
    [ExchangeSubAccountStackRoutes.SelectExchange]: {
      path: 'exchange-sub-account/select-exchange'
    },
    [ExchangeSubAccountStackRoutes.InstructionSubmitted]: {
      path: 'exchange-sub-account/submitted-exchange'
    }
  },
  i18n: {
    en: en as Record<string, any>,
    'zh-HK': zhHk as Record<string, any>,
    'zh-CN': zhCn as Record<string, any>,
    'ja-JP': jaJp as Record<string, any>
  }
};

export default ExchangeSubAccountApp;
